import api from '@/api';

const types = {
  SET_QUIZZES: 'SET_QUIZZES',
};

const state = {
  quizzes: null,
};

const getters = {
  getQuizzes: (state) => state.quizzes,
};

const mutations = {
  [types.SET_QUIZZES](state, quizzes) {
    state.quizzes = quizzes;
  },
};

const actions = {
  async getQuizzes({ commit }) {
    const response = await api.quizList();
    if (response && (response.status === 200 || response.status === 204)) {
      commit(types.SET_QUIZZES, response.data);
    }
    return response;
  },
};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters,
};
